/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _, Backbone, DateRange, JSWidget, mp, RelativeDate */

/**
 * This file provides the DatePicker widget
 *
 * @returns mp.widgets.DatePicker
 * @returns mp.widgets.Picker
 *
 * @requires JSWidget
 * @requires mp.widgets.Dropdown
 * @requires mp.widgets.dropdowns.Rounded
 * @requires mp.widgets.Calendar
 * @requires date.js
 * @requires DateRange (date_range.js)
 * @requires RelativeDate (date_range.js)
 */



_.namespace(`mp.widgets`, function(ns) {
  "use strict";

  function DatePicker() {
    this.class_name = `date_picker`;
    this._callbacks = [];
  }
  _.inherit(DatePicker, JSWidget);

  DatePicker.prototype.create = function(div, entries, config) {
    DatePicker.superclass.create.call(this, div);

    this._entries = entries || [
      new DateRange(new RelativeDate(0), `Today`),
      new DateRange(new RelativeDate(-1), new RelativeDate(-1), `Yesterday`),
      new DateRange(new RelativeDate(-6), `Past week`),
      new DateRange(new RelativeDate(-29), `Past 30 days`),
    ];

    this._entries.push([`picker`, `Pick a date range...`]);

    this.config = _.extend({}, config);

    this.value = this._entries[0];

    this.dropdown = new DateDropdown().create($(`<div>Select a Date</div>`), this._entries, this.config);
    this.dropdown.body.container.on(`body-activated`, _.bind(function() {
      if (this.upsell_popup) {
        this.upsell_popup.close();
      }
    }, this));
    this.dropdown.body.widgets.forEach(_.bind(function(date_item) {
      // Feature gating
      var from_date = date_item.value._from;
      if (from_date instanceof RelativeDate) {
        from_date = from_date.to_date();
      }
      if (from_date < mp.utility.get_oldest_allowed_date_from_feature_gate_set()) {
        date_item.disable();
        date_item.container.addClass(`feature-gated`);
        date_item.container.on(`disabled-dropdown-item-selected`, _.bind(function() {
          this.dropdown.body.deactivate();
          if (!this.upsell_popup) {
            this.upsell_popup = new Backbone.widgets.Upsell.Popup({
              type: `date_picker`,
              className: `date_picker`,
              css: {
                left: 0,
                top: 42,
                'min-width': `288px`,
              },
              text: Backbone.widgets.Upsell.copy.date_range,
            }).on(`close`, _.bind(function() {
              this.upsell_popup = null;
            }, this));
            this.dropdown.container.append(this.upsell_popup.$el);
          }
        }, this));
      }
    }, this));
    this.picker = new Picker().create($(`<div></div>`), this.config);

    this.container.append(
      this.dropdown.container,
      this.picker.container
    );

    this.bindings();

    return this;
  };

  DatePicker.prototype.onchange = function(callback) {
    this._callbacks.push(callback);
  };

  DatePicker.prototype.bindings = function() {
    var change = _.bind(function(date_range) {
      this.value = date_range;
      _.each(this._callbacks, function(cb) {
        cb.call(cb, date_range);
      });
    }, this);

    this.dropdown.onchange(_.bind(function(item) {
      if (item.is_picker) {
        mp.utility.bind_esc(this.id, function(ev) {
          this.set_state(this.dropdown, true);
        }, this);
        this.set_state(this.picker);
        _.defer(_.bind(function() { // do this after clickoutside has been dealt with
          this.picker.from_calendar.activate();
        }, this));
      } else {
        change(item.val());
      }
    }, this));

    this.picker.onchange(_.bind(function(date_range) {
      change(date_range);
    }, this));

    this.picker.oncollapse(_.bind(function() {
      this.set_state(this.dropdown);
    }, this));
  };

  DatePicker.prototype.set_dates = function(date_range, skip_event) {
    for (var i = 0; i < this._entries.length; i++) {
      var entry = this._entries[i];
      if ((entry instanceof DateRange) && entry.equals(date_range)) {
        this.value = this._entries[i];
        this.set_state(this.dropdown, skip_event);
        return;
      }
    }

    this.value = date_range;
    this.set_state(this.picker, skip_event);
  };

  DatePicker.prototype.get_dates =
    DatePicker.prototype.selected = function() {
      return this.value;
    };

  DatePicker.prototype.set_state = function(widget, skip_event) {
    widget.select_date_range(this.value, skip_event);

    this.dropdown.container.hide();
    this.picker.container.hide();
    widget.container.css(`display`, `inline-block`);
    if (widget !== this.picker) {
      mp.utility.unbind_esc(this.id);
    }
  };

  DatePicker.prototype.collapse = function() {
    this.picker.collapse();
  };

  DatePicker.prototype.disable = function() {
    this.set_state(this.dropdown, true);
    this.dropdown.disable();
    this.container.addClass(`disabled`);
  };

  DatePicker.prototype.enable = function() {
    this.dropdown.enable();
    this.container.removeClass(`disabled`);
  };

  DatePicker.prototype.set_max_days = function(max_days) {
    this.picker.config.max_days = max_days;

    var from_date = this.get_dates().from(),
      to_date = this.get_dates().to(),
      max_from_date = to_date.clone().addDays(-max_days);

    if (from_date.isBefore(max_from_date)) {
      this.set_dates(new DateRange(max_from_date, to_date));
    }
  };

  DatePicker.prototype.set_limits = function(min_date, max_date) {
    this.picker.set_limits(min_date, max_date);
  };

  function Picker() {
    this.class_name = `picker`;
    this._change_callbacks = [];
    this._collapse_callbacks = [];
  }
  _.inherit(Picker, JSWidget);

  Picker.prototype.default_config = function() {
    return {
      max_days: 365,
      hide_done: false,
      min_date: null,
      max_date: null,
    };
  };

  Picker.prototype.create = function(div, config) {
    Picker.superclass.create.call(this, div);

    this.config = _.extend(this.default_config(), config);

    this.from_calendar = new mp.widgets.Calendar()
      .create($(`<div>Start Date</div>`).addClass(`from_picker`));
    this.to_calendar = new mp.widgets.Calendar()
      .create($(`<div>End Date</div>`).addClass(`to_picker`));

    // set minDate and maxDate on the calendar
    this.set_limits(this.config.min_date, this.config.max_date);

    this.container.hide().append(
      this.from_calendar.container,
      $(`<span>`).html(`&ndash;`).addClass(`to`),
      this.to_calendar.container
    );

    if (!this.config.hide_done) {
      this.done_button = $(`<div>`).addClass(`button_primary button`).html(`Done`);
      this.container.append(this.done_button);
    }

    this.bindings();

    return this;
  };

  Picker.prototype.bindings = function() {
    var change = _.debounce(_.bind(function() {
      var date_range = this.date_range();
      _.each(this._change_callbacks, function(cb) { cb(date_range); });
    }, this), 100);

    this.from_calendar.onchange(_.bind(function() {
      var date_range = this.date_range(),
        fd = date_range.from(),
        td = date_range.to();

      if (fd && td) {
        var days = date_range.days();
        if (days > this.config.max_days) {
          this.to_calendar.set_date(fd.clone().add({days: this.config.max_days}));
        } else if (days <= 0) {
          // we moved the left side past the right side
          // set the right side to the value of the left
          this.to_calendar.set_date(fd);
        }
      }

      change();
    }, this));

    this.to_calendar.onchange(_.bind(function() {
      var date_range = this.date_range();

      var days = date_range.days();
      if (days <= 0) {
        // right side date is before the left side
        // set left side to the value of the right
        this.from_calendar.set_date(date_range.to());
      } else if (days > this.config.max_days) {
        this.from_calendar.set_date(
          date_range.to().clone().add({days: -this.config.max_days})
        );
      }

      if (date_range.from() && date_range.to()) {
        change();
      }
    }, this));

    if (!_.isUndefined(this.done_button)) {
      this.done_button.click(_.bind(this.collapse, this));
    }
  };

  Picker.prototype.collapse = function() {
    _.each(this._collapse_callbacks, function(cb) { cb(); });
  };

  Picker.prototype.onchange = function(callback) {
    this._change_callbacks.push(callback);
  };

  Picker.prototype.oncollapse = function(callback) {
    this._collapse_callbacks.push(callback);
  };

  Picker.prototype.val = function() {
    var fd = this.from_calendar.val(),
      td = this.to_calendar.val();
    return new DateRange(fd, td);
  };
  Picker.prototype.date_range = Picker.prototype.val;

  Picker.prototype.set_dates = function(date_range, skip_event) {
    this.from_calendar.set_date(date_range.from(), skip_event);
    this.to_calendar.set_date(date_range.to(), skip_event);
  };
  Picker.prototype.select_date_range = Picker.prototype.set_dates;

  Picker.prototype.set_limits = function(min_date, max_date) {
    if (min_date instanceof Date) {
      this.from_calendar.set_option(`minDate`, min_date);
      this.to_calendar.set_option(`minDate`, min_date);
    }
    if (max_date instanceof Date) {
      this.from_calendar.set_option(`maxDate`, max_date);
      this.to_calendar.set_option(`maxDate`, max_date);
    }
  };

  function DateDropdown() {
    this.class_name = `date_dropdown`;
    this.label_class = Label;
    this.body_class = Body;
  }
  _.inherit(DateDropdown, mp.widgets.dropdowns.Rounded);

  DateDropdown.prototype.default_config = function() {
    var c = DateDropdown.superclass.default_config.apply(this, arguments);
    return _.extend(c, {
      emulate_select: true,
      menu: true,
    });
  };

  DateDropdown.prototype.select_date_range = function(date_range, skip_event) {
    var picker_item,
      item = _.find(this.body.widgets, function(itm) {
        if (itm.is_picker) { picker_item = itm; return false; }
        return itm.value instanceof DateRange && itm.value.equals(date_range);
      });
    if (item) {
      this.select_item(item, skip_event);
    } else {
      picker_item._set_value(date_range);
      this.select_item(picker_item, skip_event);
    }
  };

  function Label() {
    this.class_name = `rounded_dropdown_label`;
  }
  _.inherit(Label, mp.widgets.styled_labels.Rounded);

  Label.prototype.create = function(div, options) {
    Label.superclass.create.apply(this, arguments);

    return this;
  };

  Label.prototype._set_content = function(item) {
    if (item.value instanceof DateRange) {
      item = item.value.toString(`MMM d, yyyy`);
    }
    Label.superclass._set_content.call(this, item);
  };

  function Body() {
    this.class_name = `rounded_dropdown_body`;
    this.item_class = Item;
  }
  _.inherit(Body, mp.widgets.dropdowns.Rounded.Body);

  Body.prototype.label_changed = function(ev, label) {
    this.container.css(`min-width`, label.container.outerWidth() - 2);
  };

  function Item() {
    this.class_name = `rounded_dropdown_item`;
  }
  _.inherit(Item, mp.widgets.dropdowns.Rounded.Item);

  Item.prototype._set_content = function(date_range) {
    if (date_range instanceof DateRange) {
      date_range = date_range.label();
    }

    Item.superclass._set_content.call(this, date_range);
  };

  Item.prototype._set_value = function(val) {
    if (_.isArray(val) && val[0] === `picker`) {
      this.is_picker = true;
    }
    Item.superclass._set_value.apply(this, arguments);
  };

  DateDropdown.Label = Label;
  DateDropdown.Body = Body;
  DateDropdown.Item = Item;

  return {
    DatePicker,
    Picker,
  };
});

}.call(window));